import { useState } from "react";
import { Loading, Typography } from "@/components/atoms";
import { useGetBookingTripLogsQuery } from "@/redux/apis/booking/bookingApi";
import { BookingMarkerState } from "../../../../BookingTripMap/types";
import { useSelectedBooking } from "../../../hooks/useSelectedBooking";
import { DriverActionsSection } from "../../../shared/sections/DriverActionsSection";
import { PaymentSection } from "../../../shared/sections/PaymentSection";
import { TripSection } from "../../../shared/sections/TripSection";
import { TripBasicDetails, TripMapWrapper } from "../../TripActivity/TripActivity";
import { ActualLandingTimeCard } from "./cards/ActualLandingTimeCard";
import { BookingTimeCard } from "./cards/BookingTimeCard";
import { CompanyCard } from "./cards/CompanyCard";
import { DriverNotesCard } from "./cards/DriverNotesCard";
import { ExtrasCard } from "./cards/ExtrasCard";
import { TransferTypeCard } from "./cards/TransferTypeCard";
import { VehicleCategoryCard } from "./cards/VehicleCategoryCard";

export const ViewTripDriverActivity = ({ open }: { open: boolean }) => {
  const booking = useSelectedBooking();
  const { id: bookingId } = booking;
  const { data: bookingTrip } = useGetBookingTripLogsQuery(bookingId, { skip: !open });
  const [markerState, setMarkerState] = useState<BookingMarkerState>({});

  return (
    <div className="flex-1 space-y-6">
      <Typography variant="title">Trip Summary</Typography>

      {bookingTrip ? (
        <>
          <div>
            <TripBasicDetails />
            <TripMapWrapper
              bookingTrip={bookingTrip}
              markerState={markerState}
              setMarkerState={setMarkerState}
              readOnly={false}
              height={425}
              showOverrideForm={true}
            />
          </div>

          <div className="grid grid-cols-1 gap-2 pt-0 lg:grid-cols-2">
            <div className="space-y-2.5">
              <BookingTimeCard booking={booking} />
              <TripSection booking={booking} showViewTripActivityButton={false} />
              <CompanyCard booking={booking} />
              <DriverNotesCard booking={booking} />
              <DriverActionsSection booking={booking} />
            </div>

            <div className="space-y-2.5">
              <TransferTypeCard booking={booking} />
              <VehicleCategoryCard booking={booking} />
              <ActualLandingTimeCard booking={booking} />
              <ExtrasCard booking={booking} />
              <PaymentSection booking={booking} showDisclosureButton={false} showPaymentStatus={false} showPaymentMethod={false} />
            </div>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};
